export const brandCodes = ['307AM', '307JBM'];
